import FreeQuizSessionDialog from "@features/auth/components/dialogs/FreeQuizSessionDialog";
/* ----------------- Constants --------------- */
import { useAppStore } from "@hooks/useAppStore";

/* ----------------- Features --------------- */
import useExams from "@hooks/useExams";

/* ----------------- Helpers --------------- */
import { isWeb } from "@helpers/platform";

/* ----------------- Router --------------- */
import { useRouter } from "expo-router";

/* ----------------- React --------------- */
import { useState } from "react";

import { cacheKeys } from "@constants/cache-keys";
import { useQueryClient } from "@tanstack/react-query";
/* ----------------- UI Components --------------- */
import { Button } from "react-native-paper";

type Props = {
	cta: string;
	productId: string;
	handleDismiss?: () => void;
	switchExamContext: () => Promise<boolean>;
};
export const GenerateFreeQuizButton = ({
	cta,
	productId,
	handleDismiss,
	switchExamContext,
}: Props) => {
	const router = useRouter();
	const { examsList: exams } = useExams();

	const [showFreeQuizDialog, setShowFreeQuizDialog] = useState(false);

	const queryClient = useQueryClient();

	const exam = useAppStore((store) => store.exam);

	const isQuizEnabled = exam?.quizEnabled;

	const examDetails = exams.find((examDetails) =>
		examDetails.exam.bundles.find(
			(bundleDetails) => bundleDetails.bundle.id === productId,
		),
	);

	const practiceTestProduct = examDetails?.exam.bundles.find(
		(item) => item.bundle.bundleType === "PRACTICE_TEST",
	);
	const practiceTestProductId = practiceTestProduct?.bundle.id;

	const handleShowFreeQuizDialog = async () => {
		await switchExamContext();
		setShowFreeQuizDialog(true);
	};

	const defaultCta = "Go to home";
	return (
		<>
			{isWeb && practiceTestProductId && isQuizEnabled && (
				<Button
					style={{
						marginHorizontal: 16,
					}}
					onPress={handleShowFreeQuizDialog}
					mode="contained"
				>
					{cta}
				</Button>
			)}
			<Button
				style={{
					marginHorizontal: 16,
				}}
				onPress={async () => {
					queryClient.invalidateQueries({
						queryKey: [cacheKeys.productMetadata, productId],
					});
					await switchExamContext();
					handleDismiss?.();
					router.push("/home");
				}}
			>
				{defaultCta}
			</Button>
			{showFreeQuizDialog && (
				<FreeQuizSessionDialog
					visible={showFreeQuizDialog}
					onClose={(navigate?: boolean) => {
						setShowFreeQuizDialog(false);
						if (navigate) {
							router.push("/home");
						}
					}}
				/>
			)}
		</>
	);
};
